;(function () {
  var nav = document.querySelector('.mkt-nav-transition')
  if (!nav) return

  var sections = document.querySelectorAll('[data-nav-theme]')
  var active = new Set()

  function apply() {
    var visible = Array.from(active).sort(function (a, b) {
      return a.getBoundingClientRect().top - b.getBoundingClientRect().top
    })
    var top = visible[0]
    if (!top) return
    var theme = top.dataset.navTheme
    nav.classList.toggle('mkt-nav--light', theme === 'light')
    nav.classList.toggle('mkt-nav--canvas', theme === 'canvas')
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) active.add(e.target)
        else active.delete(e.target)
      })
      apply()
    },
    { rootMargin: '-60px 0px -55% 0px', threshold: 0 }
  )

  sections.forEach(function (s) {
    observer.observe(s)
  })
})()
